<template>
    <div class="bar-chart">
        <ECharts :option="options" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/core";
import { DatasetComponent, GridComponent, TransformComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([DatasetComponent, GridComponent, TransformComponent, BarChart, CanvasRenderer]);

console.log("echarts", echarts);
Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=data-transform-filter
export default Vue.extend({
    name: "BarChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Chart",
        },
        yAxis: {
            type: Array,
            default: () => [],
        },
        legend: {
            type: Array,
            default: () => [],
        },
        xAxisData: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Object,
        },
        colors: {
            type: Array,
            default: () => [],
        },
    },
    methods: {},
});
</script>

<style scoped lang="scss">
.bar-chart {
    width: 100%;
    min-height: 300px;

    .echart-graph {
        width: 100%;
        height: 100%;
        min-height: 400px;
    }
}
</style>
